
import { SubjectSelector, SubjectTypeSelector,
         ProgramSelector,
         FeatureTypeSelector } from "@Beasted1010/pivotal-wisdom";




// TODO: Move to a type file... ?
interface IFetchUpdateOptions {
  subjectSelector?: SubjectSelector,
  programSelector?: ProgramSelector,
  featureSelector?: FeatureTypeSelector,

  progressType?: any, // ProgressEventType, // TODO: Use once moved to Shared Library
  progressDetails?: any,

  engagementType?: any, // EngagementType, // TODO: Use once moved to Shared Library
  engagementDetails?: any,

  interactionType?: any, // InteractionType, // TODO: Use once moved to Shared Library
  interactionDetails?: any,

  feedbackType?: any, // FeedbackType, // TODO: Use once moved to Shared Library
  feedbackDetails?: any,


  additionalDetails?: any;
}


async function reportProgress( {progressType, progressDetails, subjectSelector, programSelector, featureSelector, additionalDetails}: IFetchUpdateOptions ) {

  const URL = `/api/v1/analytics/progress?progressType=${progressType}`;

  const payload = {
    progressDetails,

    subjectSelector,
    programSelector,
    featureSelector,

    additionalDetails,
  };

  const blob = new Blob( [JSON.stringify(payload)], { type: "application/json" } );

  navigator.sendBeacon( URL, blob );
}


// Meant for "high level" engagement (duration, view, etc.) - e.g. page view, video view, etc.
async function reportEngagement( {engagementType, engagementDetails, additionalDetails}: IFetchUpdateOptions ) {

  const URL = `/api/v1/analytics/engagement?engagementType=${engagementType}`;

  const payload = {
    engagementDetails,
    additionalDetails,
  };

  const blob = new Blob( [JSON.stringify(payload)], { type: "application/json" } );

  navigator.sendBeacon( URL, blob );
}


// Meant for "low level" interaction (specific elements, actions, etc.) - e.g. click, submit, hover, etc.
async function reportInteraction( {interactionType, interactionDetails, additionalDetails}: IFetchUpdateOptions ) {

  const URL = `/api/v1/analytics/interaction?interactionType=${interactionType}`;

  const payload = {
    interactionDetails,
    additionalDetails,
  };

  const blob = new Blob( [JSON.stringify(payload)], { type: "application/json" } );

  navigator.sendBeacon( URL, blob );
}


async function reportFeedback( {feedbackType, feedbackDetails, additionalDetails}: IFetchUpdateOptions ) {

  const URL = `/api/v1/analytics/feedback?feedbackType=${feedbackType}`;

  const payload = {
    feedbackDetails,
    additionalDetails,
  };

  const blob = new Blob( [JSON.stringify(payload)], { type: "application/json" } );

  navigator.sendBeacon( URL, blob );
}








export {
  reportProgress,
  reportEngagement,
  reportInteraction,
  reportFeedback,
}
